export const FINGERPRINT_REQUEST_ID = "fingerprint_request_id";
export const FINGERPRINT_PSK_ID = "fingerprint_psk_id";
export const FINGERPRINT_VISITOR_ID = "fingerprint_visitor_id";

export const LoginImageUrls = [
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703120910863358.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703120932365743.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703120945825091.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121000916710.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121014377499.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121027907346.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121046380762.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121057898157.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121112803858.webp",
  "https://parkplus-bkt-img.parkplus.io/production/signin/public/banner_20240703121141850203.webp",
];
